import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import "../css/returns.scss";

function Returns() {
  return (
    <div className="returns">
      <Header />
      <div className="main-content full-width inner-page">
        <div className="background-content" />
        <div className="background">
          <div className="shadow" />
          <div className="pattern">
            <div className="container">
              <div className="row">
                <div className="col-md-12">
                  <div className="row">
                    <div
                      className="col-md-12 center-column content-with-background"
                      id="content"
                    >
                      <div style={{ paddingBottom: 10 }}>
                        <div className="pdh-page pdh-policy-page">
                          <section className="pdh-section pdh-container">
                            <h1 className="pdh-policy-title">
                              Returns &amp; Refunds
                            </h1>
                            <div className="pdh-policy-layout">
                              <div className="pdh-policy-main">
                                <div className="pdh-policy-sections">
                                  {/* 1. Return Policy */}
                                  <div className="pdh-policy-section">
                                    <ol start={1}>
                                      <li className="pdh-policy-section-title">
                                        Return Policy
                                      </li>
                                    </ol>
                                    <div className="pdh-policy-section-content">
                                      <p className="pdh-policy-text">
                                        We want you and your pet to be
                                        completely happy with your purchase. If
                                        for any reason you are not satisfied,
                                        you may return items within 30 days of
                                        the original purchase date.
                                      </p>
                                      <p className="pdh-policy-text">
                                        To be eligible for a return, the item
                                        must be unused, in the same condition
                                        that you received it, and in its
                                        original packaging.
                                      </p>
                                    </div>
                                  </div>

                                  {/* 2. How to Return */}
                                  <div className="pdh-policy-section">
                                    <ol start={2}>
                                      <li className="pdh-policy-section-title">
                                        How to Return
                                      </li>
                                    </ol>
                                    <div className="pdh-policy-section-content">
                                      <p className="pdh-policy-text">
                                        To initiate a return, please contact our
                                        customer support team at{" "}
                                        <a
                                          href="mailto:stock@pawluna.art"
                                          className="pdh-policy-link"
                                        >
                                          stock@pawluna.art
                                        </a>{" "}
                                        with your order number and the reason
                                        for your return.
                                      </p>
                                      <ul className="pdh-policy-disc-list">
                                        <li>
                                          We will provide you with a return
                                          authorization number and instructions
                                          on where to send your package.
                                        </li>
                                        <li>
                                          Please note that customers are
                                          responsible for paying their own
                                          shipping costs for returning an item.
                                          Shipping costs are non-refundable.
                                        </li>
                                      </ul>
                                    </div>
                                  </div>

                                  {/* 3. Refunds */}
                                  <div className="pdh-policy-section">
                                    <ol start={3}>
                                      <li className="pdh-policy-section-title">
                                        Refunds
                                      </li>
                                    </ol>
                                    <div className="pdh-policy-section-content">
                                      <p className="pdh-policy-text">
                                        Once your return is received and
                                        inspected, we will send you an email to
                                        notify you that we have received your
                                        returned item. We will also notify you
                                        of the approval or rejection of your
                                        refund.
                                      </p>
                                      <p className="pdh-policy-text">
                                        If approved, your refund will be
                                        processed, and a credit will
                                        automatically be applied to your credit
                                        card or original method of payment
                                        within a certain amount of days.
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </section>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default Returns;
